import { contratoCuotaApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
  getListByParentDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'CONTRATO_CUOTA',
    api: contratoCuotaApi,
    relUrl: id,
  });

export const getAllByParent = (id) =>
  getListByParentDataAction({
    dataName: 'CONTRATO_CUOTA',
    api: contratoCuotaApi,
    relUrl: `indexByParent/${id}`,
  });

export const getAll = getListDataAction({
  dataName: 'CONTRATO_CUOTA',
  api: contratoCuotaApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'CONTRATO_CUOTA',
    api: contratoCuotaApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'CONTRATO_CUOTA',
    api: contratoCuotaApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'CONTRATO_CUOTA',
  api: contratoCuotaApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'CONTRATO_CUOTA',
    api: contratoCuotaApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('CONTRATO_CUOTA');
export const setDeletedPending = createListDataDeletedPending('CONTRATO_CUOTA');
